export default {
   isActive: false,
   demoEmail: "demo@philbi.de",
}